import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { saveAs } from "file-saver";
import { UtilityService } from "services/utility.service";
import { text } from "adminModules/ulb-proposals/national-action-plan/doc";
import { Observable } from "rxjs/internal/Observable";
import { Route, Router } from "@angular/router";
import { LogsService } from "./log.service";

@Injectable()
export class HttpService {
  host: string = environment.config.apiUrl;
  static: string = environment.config.staticUrl;

  systemSettingsUrl = environment.config.systemSettings;
  ssoUrl =
    this.util?.getUserRole() === "GFC_VENDOR" ||
    this.util?.getUserRole() === "ODF_VENDOR" ||
    this.util?.getUserRole() === "VENDOR"
      ? environment.config.vendorSso
      : environment.config.loginUrl;

  userServiceUrl = this.ssoUrl + "user/";
  gfcVendorUrl = environment.config.vendorSso + "user/";

  encryptSecretKey =
    "hbaerfewrifqrqrefYQGRyuqeurQRqRF&#*$R#&$YR*@Y$&#$*YUERVEAvfu";
  loading = false;

  loginUrl = this.host + "manufacturer/user-login";
  checkUserApprovalUrl = this.host + "manufacturer/status";

  basicRegistrationUrl = this.host + "manufacturer/basic-registration";
  verifyOTPUrl = this.host + "manufacturer/verify-otp";

  // Master Data
  stateListUrl = this.host + "master/state-list";
  districtListUrl = this.host + "master/district-list";
  ulbListUrl = this.host + "master/ulb-list";

  manufactureFormUrl = this.host + "manufacturer/manufacturer-registration";
  updateDirectorsUrl = this.host + "manufacturer/update-directors";

  getManufactureFormUrl = this.host + "manufacturer/";
  getPlantsUrl = this.host + "dashboard/plant-list";
  plantInfoUrl = this.host + "plant/plant-registration";
  getPlantListUrl = this.host + "plant/plantInfoGet";
  addWasteUrl = this.host + "waste/waste-add";
  monthlyWasteListUrl = this.host + "waste/waste-list-monthly";
  wasteListUrl = this.host + "waste/waste-list";

  addCompostUrl = this.host + "compost/create-compost";
  compostListUrl = this.host + "compost/compost-list";
  updateCompostUrl = this.host + "compost/update-compost";
  addWateUrl = this.host + "waste/waste-add";
  addSellInfoUrl = this.host + "trasaction/sell-compost";
  sellInfoListUrl = this.host + "trasaction/get-composts";
  plantInfoFormUrl = this.host + "";
  compostFilterUrl = this.host + "compost/filter";
  wasteFilterUrl = this.host + "waste/filter";
  createSell_compostUrl = this.host + "trasaction/createSell";

  wasteUpdateIDUrl = this.host + "waste/get_waste";
  compostUpdateIDUrl = this.host + "compost/get_compost";
  compostUpdateUrl = this.host + "waste/update-waste";
  getSellDataUrl = this.host + "trasaction/get-composts";
  sellInfoIDUrl = this.host + "trasaction/sellInfoID";
  sellFilterUrl = this.host + "trasaction/filter";

  companyListUrl = this.host + "ulb/getAllCompany";
  companyListSearchUrl = this.host + "ulb/filter";
  viewPlantListUrl = this.host + "plant/plantInfoGet";
  viewPlantListSearchUrl = this.host + "plant/filter";
  compostProductionListUrl = this.host + "";
  compostProductionSearchUrl = this.host + "";
  plantInformationUrl = this.host + "plant/plant-registration";
  viewCompanyListUrl = this.host + "ulb/getCompanyInfo";
  getVerifyCompostListUrl = this.host + "compost/compost-list";
  verifyCompostDataUrl = this.host + "compost/compostRecord";
  verifyCompostFilterUrl = this.host + "compost/filter";
  getallplantUrl = this.host + "plant/get-plant-list";

  getDataForSaleUrl = this.host + "trasaction/sale";
  dashboardUrl = this.host + "dashboard";
  getManufacturerUrl = this.host + "manufacturer/getManufacturer";

  // getPlantByUlbUrl = this.host + 'plant/getAllplant';
  getCompanyListUrl = this.host + "ulb/company/list";

  viewCompanyListSubmitUrl = this.host + "ulb/verifiedCompanyDetail";

  manufacturerId: string;
  moduleName: string;
  constructor(
    private http: HttpClient,
    private snackbar: MatSnackBar,
    private util: UtilityService,
    private router: Router,
    private logs: LogsService
  ) {}

  setSsoUrl() {
    this.ssoUrl =
      this.util?.getUserRole() === "GFC_VENDOR" ||
      this.util?.getUserRole() === "ODF_VENDOR" ||
      this.util?.getUserRole() === "VENDOR"
        ? environment.config.vendorSso
        : environment.config.loginUrl;
  }

  uploadPhoto(data) {
    return this.http.post<any>(this.static + "upload", data);
  }

  errorMessage(err) {
    this.loading = false;
    if (err instanceof HttpErrorResponse) {
      if (err.status === 404 && err.error.errors) {
        console.log(err);
        const message = err.error.errors[0].message;
        if (
          message === "jwt expired" ||
          message === "invalid signature" ||
          message === "jwt malformed"
        ) {
          console.log("Your Session has Expired");
          setTimeout(() => {
            console.log("Login to Continue");
          }, 4000);
        } else {
          console.log("Error");
        }
        return message;
      } else if (err.status === 0) {
        console.log("Server Unreachable");
      }
    }
    if (err.status === 0) {
      console.log(
        "<<<<<<<<<<<<<<<<<<<<<<<<<<<No Connection>>>>>>>>>>>>>>>>>>",
        err
      );
      console.log("Please check your connection.....");
      setTimeout(() => {
        console.log("Please check your connection.....");
      }, 5000);
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(".ng-invalid");
    this.scrollTo(firstElementWithError);
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  showMsg(msg: string, type: string = "Success") {
    this.snackbar.open(msg, type, {
      duration: 5000,
    });
  }

  loginUser(data) {
    return this.http.post<any>(this.loginUrl, data);
  }

  checkUserApproval() {
    return this.http.get<any>(this.checkUserApprovalUrl);
  }

  updatePassword(endpoint: string, data) {
    return this.http.post<any>(this.ssoUrl + "user/" + endpoint, data, {
      observe: "response",
    });
  }

  addUser(data) {
    return this.http.post<any>(this.userServiceUrl + "register", data, {
      observe: "response",
    });
  }
  updateUser(username, data) {
    return this.http.put<any>(this.userServiceUrl + `${username}/`, data, {
      observe: "response",
    });
  }
  addContactToUser(data) {
    return this.http.post<any>(this.ssoUrl + `profile/`, data, {
      observe: "response",
    });
  }
  updateProfile(username, data) {
    return this.http.put<any>(this.ssoUrl + `profile/user/${username}/`, data, {
      observe: "response",
    });
  }
  getProfileHistory(user) {
    return this.http.get<any>(this.ssoUrl + `profile/user/${user}/`, {
      observe: "response",
    });
  }
  addOfficial(data) {
    return this.http.post<any>(
      this.userServiceUrl + "register/official",
      data,
      { observe: "response" }
    );
  }
  otpSendTo(username) {
    return this.http.get<any>(
      this.userServiceUrl + `forget-password/otp-send-to/${username}`,
      { observe: "response" }
    );
  }
  resendOtp(username) {
    return this.http.get<any>(
      this.userServiceUrl + `otp/resend/${username}/mobile`,
      { observe: "response" }
    );
  }
  verifyOtp(username, otp, captcha) {
    return this.http.get<any>(
      this.userServiceUrl + `otp/verify/${username}/${otp}/${captcha}`,
      { observe: "response" }
    );
  }
  getUserList(query) {
    return this.http.get<any>(this.userServiceUrl, {
      params: { ...query, offset: query.offset + 1 },
    });
  }
  getUserListwithFilter(query) {
    return this.http.get<any>(this.userServiceUrl + "filter", {
      params: { ...query, offset: query.offset + 1 },
    });
  }
  getRoleDropDown() {
    return this.http.get<any>(this.ssoUrl + "access");
  }
  generateUsername(data) {
    return this.http.post<any>(this.userServiceUrl + "username", data, {
      observe: "response",
    });
  }
  basicRegistration(data) {
    return this.http.post<any>(this.basicRegistrationUrl, data);
  }
  getRegistrationData() {
    return this.http.get<any>(this.basicRegistrationUrl);
  }
  verifyOTP(data) {
    return this.http.post<any>(this.verifyOTPUrl, data);
  }

  // ===============================================================================

  manufactureRegisterForm(data) {
    return this.http.post<any>(this.manufactureFormUrl, data);
  }
  getPlantFormData() {
    return this.http.get<any>(this.getManufactureFormUrl);
  }

  plantInfoForm(data) {
    return this.http.post<any>(this.plantInfoUrl, data);
  }
  getPlants() {
    return this.http.get<any>(this.getPlantsUrl);
  }
  getPlantDetail(id) {
    return this.http.get<any>(this.getPlantListUrl + "/" + id);
  }
  getPlantList(data) {
    return this.http.post<any>(this.getPlantListUrl, data);
  }
  addWaste(data) {
    return this.http.post<any>(this.addWasteUrl, data);
  }
  getWasteList(data) {
    return this.http.post<any>(this.wasteListUrl, data);
  }

  getMonthlyWasteList() {
    return this.http.get<any>(this.monthlyWasteListUrl);
  }

  addCompost(data) {
    return this.http.post<any>(this.addCompostUrl, data);
  }
  updateCompost(data) {
    return this.http.post<any>(this.updateCompostUrl, data);
  }

  getCompostList(data) {
    return this.http.post<any>(this.compostListUrl, data);
  }

  addSellInfoForms(data) {
    return this.http.post<any>(this.addSellInfoUrl, data);
  }

  getSellInfoList() {
    return this.http.get<any>(this.sellInfoListUrl);
  }

  plantInformationForm() {
    return this.http.get<any>(this.plantInfoFormUrl);
  }
  compostFilter(data) {
    return this.http.post<any>(this.compostFilterUrl, data);
  }

  wasteFilter(data) {
    return this.http.post<any>(this.wasteFilterUrl, data);
  }

  createSell_compost(data) {
    return this.http.post<any>(this.createSell_compostUrl, data);
  }

  wasteUpdateID(data) {
    return this.http.post<any>(this.wasteUpdateIDUrl, data);
  }

  compostUpdateID(data) {
    return this.http.post<any>(this.compostUpdateIDUrl, data);
  }

  updateWaste(data) {
    return this.http.post<any>(this.compostUpdateUrl, data);
  }

  getSellData(data) {
    return this.http.post<any>(this.getSellDataUrl, data);
  }

  sellInfoID(data) {
    return this.http.post<any>(this.sellInfoIDUrl, data);
  }

  sellFilter(data) {
    return this.http.post<any>(this.sellFilterUrl, data);
  }

  getCompanyList(data) {
    return this.http.post<any>(this.companyListUrl, data);
  }

  companyListSearch(data) {
    // search
    return this.http.post<any>(this.companyListSearchUrl, data);
  }

  getViewPlantList(data) {
    return this.http.post<any>(this.viewPlantListUrl, data);
  }

  viewPlantSearch(data) {
    // search
    return this.http.post<any>(this.viewPlantListSearchUrl, data);
  }

  getCompostProductionList() {
    return this.http.get<any>(this.compostProductionListUrl);
  }

  compostProductionSearch(data) {
    // search
    return this.http.post<any>(this.compostProductionSearchUrl, data);
  }

  plantInfo(data) {
    return this.http.post<any>(this.plantInformationUrl, data);
  }

  viewCompanyList(id) {
    return this.http.post<any>(this.viewCompanyListUrl, { userId: id });
  }

  getVerifyCompostList() {
    return this.http.get<any>(this.getVerifyCompostListUrl);
  }

  verifyCompostData(data) {
    return this.http.post<any>(this.verifyCompostDataUrl, data);
  }

  verifyCompostFilter(data) {
    return this.http.post<any>(this.verifyCompostFilterUrl, data);
  }

  getallplant() {
    return this.http.get<any>(this.getallplantUrl);
  }
  getCompanyBasicDetail() {
    return this.http.get<any>(this.getManufacturerUrl);
  }
  getUlbCompanyOptions() {
    return this.http.get<any>(this.getCompanyListUrl);
  }

  viewCompanyListSubmit(data) {
    return this.http.post<any>(this.viewCompanyListSubmitUrl, data);
  }
  updateDirectorsInfo(data) {
    return this.http.post<any>(this.updateDirectorsUrl, data);
  }

  getDataForSale(id) {
    return this.http.get<any>(this.getDataForSaleUrl + "/" + id);
  }

  getDashboardData() {
    return this.http.get<any>(this.dashboardUrl);
  }

  // =====================================================================================

  delete(endpoint: string, id) {
    const url = this.host + endpoint + "/" + id;
    return this.http.delete<any>(url);
  }

  accessLevelOptions() {
    return this.http.get<any>(this.ssoUrl + "accessLevel");
  }

  // Official Login
  reCaptchaCheck() {
    return this.http.get<any>(this.userServiceUrl + "configuration");
  }

  getOfficialCapcha(): Observable<any> {
    return this.http.get<any>(this.userServiceUrl + `generate-captcha`);
  }
  getVendorCapcha(): Observable<any> {
    return this.http.get<any>(this.gfcVendorUrl + `generate-captcha`);
  }

  officialLogin(data) {
    return this.http.post<any>(this.userServiceUrl + "swachhatam-login", data);
  }
verifyLoginOtp(username: string, otp: string) {
  return this.http.post<any>(
    `${this.userServiceUrl}login/otp/verify/${encodeURIComponent(username)}/${encodeURIComponent(otp)}`,
    {}
  );
}
  gfcVendorLogin(data) {
    return this.http.post<any>(this.gfcVendorUrl + "swachhatam-login", data);
  }
  initForgotPassword(user) {
    return this.http.get<any>(this.userServiceUrl + "forget/" + user, {
      observe: "response",
    });
  }
  adminResetPassword(user) {
    return this.http.get<any>(this.userServiceUrl + "forget/admin/" + user, {
      observe: "response",
    });
  }

  // Support and Notifications
  uploadAttachment(data) {
    return this.http.post(this.host + "notification/upload/attachment", data, {
      observe: "response",
    });
  }
  submitQuery(data) {
    return this.http.post(this.host + "notification/notice", data, {
      observe: "response",
    });
  }

  // Common get function to call get API with endpoint including service
  get(endpoint: string) {
    return this.http.get<any>(this.host + endpoint, { observe: "response" });
  }

  // downloadFile(url) { saveAs(url); }

  saveFile(blob, filename) {
    saveAs(blob, filename);
  }
  downloadFile(fileName) {
    // debugger;
    // const blob = new Blob([fileName], { type: 'application/images' });
    const url = fileName;
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = "_blank";
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  getLogsList(data) {
    return this.http.get<any>(this.host + "logsservice/logs", { params: data });
  }

  getClickThroughLogsList(id, data) {
    return this.http.get<any>(this.host + "logsservice/logs/" + id, {
      params: data,
    });
  }

  setIntercepterLogsData(data) {
    let title: string;
    this.logs.getData().subscribe((a1) => {
      if (a1 != null && a1.label) {
        title = a1.label;
      }
    });

    if (title != "View Logs") {
      let obj = {
        activity:
          data.method != null
            ? data.method == "GET"
              ? "VIEW"
              : data.method == "PUT"
              ? "UPDATED"
              : data.method == "POST"
              ? "SUBMITTED"
              : "DELETED"
            : "",
        moduleName: title ? title : "Header",
        url: data.url,
        message: "user access " + title ? title : "Header",
        type: this.util.getAccessLevel(),
        ulbId: this.util.accessData?.ULBCode,
        stateId: this.util.accessData?.stateCode,
        districtId: this.util.accessData?.districtCode,
        ulb_name: this.util.accessData?.ULBName,
        state_name: this.util.accessData?.stateName
      };

      return this.http.post(this.host + "logsservice/logs", obj, {
        observe: "response",
      });
    }
  }

  getBlockChainLogsList(data){
    return this.http.get<any>(this.host + "gfc/blockChain/getData", { params: data });
  }

  downloadBlockChainExcel(queryData) {
    return this.http.get<any>(this.host + "gfc/blockChain/downloadExceptionReport", {
      params: queryData,
      observe: "response",
      responseType: "blob" as "json",
    });
  }
}
